import React, { Component } from 'react';
import Header from './Header';
import MentorCard from './MentorCard';
import Filter from './Filter';
import { mentors } from '../misc/db';
import '../css/App.css';
import '../css/algolia-min.css';
import history from '../history';
import LazyLoad from 'react-lazyload';
import Search from './Search';

var _ = require('lodash');

class Mentors extends Component {

  render() {
    let shuffledMentors = _.shuffle(mentors);
    let mentorCards = [];
    var str = this.props.store;
    shuffledMentors.forEach(function(mentor, index) {
      mentorCards.push(<MentorCard key={index}
                                    store={str}
                                    mentorName={mentor.mentorName}
                                    mentorTitle={mentor.mentorTitle}
                                    mentorEmail={mentor.mentorEmail}
                                    mentorMessage={mentor.mentorMessage}
                                    mentorTwitter={mentor.mentorTwitter} />);
    });

    shuffledMentors = shuffledMentors.filter(function(m) {
      return m.mentorTitle.toLowerCase().includes(str.getState().search.toLowerCase()) === true;
    });

    mentorCards = [];
    shuffledMentors.forEach(function(mentor, index) {
      mentorCards.push(
      <LazyLoad key={index} height={200} offset={[-100, 0]}>
        <MentorCard key={index}
                    store={str}
                    mentorName={mentor.mentorName}
                    mentorTitle={mentor.mentorTitle}
                    mentorEmail={mentor.mentorEmail}
                    mentorMessage={mentor.mentorMessage}
                    mentorTwitter={mentor.mentorTwitter} />
      </LazyLoad>
       );
    });

    return (
      <div>
        <Header store={str} auth={this.props.auth} />
        <h3 style={{textAlign: 'center'}}>Reach out to the mentors below and explain what you need guidance on <span role='img' aria-label='participate'>🙋</span> <span role='img' aria-label='clap'>🙌</span>!</h3>
        <h4 style={{textAlign: 'center', color: 'red'}}>If you would like to be added/removed as a mentor, message me on <a href="https://www.twitter.com/mdnahom" target="_blank">Twitter</a></h4>
        {/* <Filter store={str} /> */}
        <Search />
        {/* { mentorCards } */}
      </div>
    );
  }
}

export default Mentors;



// WEBPACK FOOTER //
// ./src/components/Mentors.js